import { observer } from 'mobx-react-lite'
import { Alert, Button, Divider, SpinnerLoader, TotalDueTodayRow } from 'shared/ui'
import { numberFormat } from 'shared/lib'
import { DropdownCards } from 'entities/Billing/ui/DropdownCards'
import { TimePeriodInfo } from 'pages/settings/ui/BillingPlan/ui/TimePeriodInfo/TimePeriodInfo'
import { useBillingUpgradePageContext } from 'pages/settings/pages/billing/pages/upgrade/context/upgradeContext'
import { SecurePaymentInfo } from 'pages/settings/ui/BillingPlan/ui/SecurePaymentInfo/SecurePaymentInfo'
import { LineItem } from 'pages/settings/ui/BillingPlan/ui/LineItem/LineItem'
import styles from './styles.module.scss'

export const UpgradeSecondRightContent = observer(() => {
  const store = useBillingUpgradePageContext()

  return (
    <div className={styles.infoContainerWrapper}>
      {store.paymentError && (
        <Alert
          item={{
            type: 'error',
            title: 'We were unable to process your payment',
            desc: 'Please select a different card',
          }}
          marginBottom={16}
        />
      )}
      <div className={styles.timePeriodInfo}>
        <TimePeriodInfo
          period={store.period}
          handleSetPeriod={(period) => {
            store.handleSetPeriod({
              key: period,
              name: period === 'monthly' ? 'Monthly' : 'Annually',
            })
          }}
          isPlanLoading={store.isPlanLoading}
          annualSavings={store.annualSavings}
          shouldShowPeriodTabs={store.shouldShowPeriodTabs}
          selectedPlanInfo={store.selectedPlanInfo}
        />
      </div>
      <div className={styles.totalPlanData}>
        {store.isPlanLoading && (
          <div className={styles.planLoading}>
            <SpinnerLoader ariaLabel={'UpgradeSecondRightContent'} size={32} />
          </div>
        )}
        <div className={styles.totalPlanDataLines}>
          {store.planLines.map((item) => (
            <LineItem key={item.title} title={item.title} value={item.value} />
          ))}
        </div>
        <Divider style={{ borderColor: 'var(--black-20)', margin: '12px 0' }} />
        <div className={styles.totalPlanDataLines}>
          {store.totalPlanData.map((item) => (
            <LineItem
              key={item.title}
              title={item.title}
              value={numberFormat({
                value: item.value,
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
              color={item.color}
            />
          ))}
        </div>
        <Divider style={{ borderColor: 'var(--black-20)', margin: '12px 0' }} />

        <TotalDueTodayRow
          totalValue={store.totalDueToday}
          nextChargeAmountDollars={numberFormat({
            value: (store.planData?.next_charge_details?.total ?? 0) / 100,
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
          nextChargeDate={store.planData?.next_charge_details?.date}
        />
      </div>
      {!store.isDowngrade && (
        <div className={styles.dropdownCardsWrapper}>
          <DropdownCards store={store.dropdownCardsStore} />
        </div>
      )}

      <div className={styles.buttonsWrapper}>
        {store.isDowngrade ? (
          <>
            <Button
              fullWidth
              text='Keep my current plan'
              typeBtn='contained'
              contained='primary'
              size='extraLarge'
              intent='default'
              className={styles.keepCurrentPlanButton}
              onClick={store.handleKeepCurrentPlan}
            />
            <Button
              fullWidth
              text='Downgrade plan'
              contained='secondary'
              size='extraLarge'
              intent='destructive'
              className={styles.downgradePlanButton}
              onClick={() => store.upgradePlan(true)}
              loading={store.isUpgrading}
              disabled={store.isUpgrading || store.downgradeContentStore.selectedReason === null}
            />
          </>
        ) : (
          <Button
            fullWidth
            text='Upgrade plan'
            typeBtn='contained'
            contained='primary'
            size='extraLarge'
            intent='positive'
            className={styles.upgradePlanButton}
            onClick={() => store.upgradePlan()}
            loading={store.isUpgrading}
            disabled={store.isUpgrading}
          />
        )}
      </div>
      <SecurePaymentInfo />
    </div>
  )
})
